import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import {
  selectTransactionById,
  selectTransactionEntities,
} from '../propertyDataSelectors/transactionSelectors.ts';
import { calculateMarketAdjustedSalePrice } from './calculateMarketAdjustedSalePrice.ts';
import {
  selectCalculatedMarketAdjustment,
  selectCalculatedMarketAdjustments,
} from './selectCalculatedMarketAdjustment.ts';

// These selectors are used to calculate the Improvements Value Ratio and the
// Site Value Ratio. Note that they are using the raw market adjustment, and not
// the market adjustment with rounding and thresholds applied.

export const selectMarketAdjustedSalePrice = createSelector(
  [selectTransactionById, selectCalculatedMarketAdjustment],
  (transaction, marketAdjustment) => {
    return calculateMarketAdjustedSalePrice({
      price: transaction?.price,
      marketAdjustment,
    });
  },
);

export const selectMarketAdjustedSalePrices = createSelector(
  [selectTransactionEntities, selectCalculatedMarketAdjustments],
  (transactions, marketAdjustments) => {
    if (isUndefined(transactions)) return {};
    return Object.fromEntries(
      Object.entries(transactions).map(([propID, transaction]) => [
        propID,
        calculateMarketAdjustedSalePrice({
          price: transaction.price,
          marketAdjustment: marketAdjustments[propID] ?? AloftPrice.zero,
        }),
      ]),
    );
  },
);
